import {
    SET_DEFAULT_STATE,
    SET_TARIFF,
    SET_DESTINATION,
    SET_COUNTRY,
} from './constants';
import { takeLatest } from 'redux-saga/effects';
import {
    setTariffTrackingSaga,
    initialTrackingSaga,
    setDestinationTrackingSaga,
    setCountryTrackingSaga,
} from './sagaFunctions/tracking';
// import { callGetCountriesSaga, callGetRoamingOptionsSaga } from './jarvis';
import {
    callGetCountriesSaga,
    callGetRoamingOptionsSaga,
} from './sagaFunctions/dataFromMarkup';

/**
 * Export generator function
 */
export default function* raSaga () {
    // JARVIS
    yield takeLatest(SET_DEFAULT_STATE, callGetCountriesSaga);
    yield takeLatest(SET_TARIFF, callGetRoamingOptionsSaga);
    // tracking
    yield takeLatest(SET_DEFAULT_STATE, initialTrackingSaga);
    yield takeLatest(SET_DESTINATION, setDestinationTrackingSaga);
    yield takeLatest(SET_COUNTRY, setCountryTrackingSaga);
    yield takeLatest(SET_TARIFF, setTariffTrackingSaga);
}
